import { Box } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { MetropolisLogoWordmark } from '@m/icons';
import { ProtectedRoutes } from 'apps/customer/routes/paths';

type MetropolisHomeLogoProps = {
  height?: number;
  width?: number;
};

export function MetropolisHomeLogo({ height, width }: MetropolisHomeLogoProps) {
  const history = useHistory();

  return (
    <Box
      asChild
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      bg="transparent"
      border="none"
      p={0}
    >
      <button
        type="button"
        aria-label="Go to home"
        onClick={() => history.push(ProtectedRoutes.HomePage)}
      >
        <MetropolisLogoWordmark height={height} width={width} />
      </button>
    </Box>
  );
}
